import { render, staticRenderFns } from "./LoanStatus.vue?vue&type=template&id=87407fe4"
import script from "./LoanStatus.vue?vue&type=script&lang=js"
export * from "./LoanStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports